var exports = {
  "kL": "xe533113f--68568b--container",
  "Nr": "xe533113f--68568b--card",
  "$_": "xe533113f--68568b--media",
  "U": "xe533113f--68568b--wide",
  "Qs": "xe533113f--68568b--content",
  "ju": "xe533113f--68568b--general",
  "HU": "xe533113f--68568b--aside",
  "sI": "xe533113f--68568b--publisher-cont",
  "t$": "xe533113f--68568b--publisher",
  "nf": "xe533113f--68568b--link",
  "Uo": "xe533113f--68568b--buttons",
};

module.exports = exports;
